import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

import { ThemeConfig } from '../../../core/helpers/theme-config'
import { UXFacet } from '../../models/ux-facets';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FacetToggleEvent } from '../../models/facet-toggle-event';

const showFacets = ThemeConfig.get<number>('catalog', 'show-more') || 10

@Component({
  selector: 'app-facet-list',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOut', [
        state('0',
          style({
            'height': 0,
            'visibility': 'hidden',
            'opacity': 0
          })),
        state('1',
          style({
            'height': '100%',
            'visibility': 'visible',
            'opacity': 1
          })),
        transition('void => 0', animate(0)),
        transition('0 <=> 1', animate('100ms linear'))
      ]
    )
  ]
})
export class FacetListComponent implements OnInit {
  @Input() facets: UXFacet[]
  @Input('applied') appliedFacets: string[]
  @Input() open = false
  @Output() facetToggled = new EventEmitter<FacetToggleEvent>()
  @Output() showMoreToggled = new EventEmitter<void>()

  isApplied(facet: UXFacet): boolean {
    return this.appliedFacets.indexOf(facet.code) !== -1
  }

  ngOnInit() {
    this.facets = this.facets.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLocaleLowerCase())
        return -1
      if (a.name.toLowerCase() > b.name.toLocaleLowerCase())
        return 1
      return 0
    })
  }

  get showFacets(): number {
    return showFacets
  }

  get hasMoreFacets() {
    return this.facets.length > this.showFacets
  }

  toggled(code: FacetToggleEvent) {
    this.facetToggled.emit(code)
  }

  showMore() {
    this.showMoreToggled.emit()
  }
}
